import {ReactElement, useEffect, useRef} from "react"
import {Button} from "antd"
import {t} from "@ui/common/intl"
import {TPoint} from "@ui/api/poi"
import mapService from "@ui/services/MapService"
import {PoiPage, TPoiPageProps} from "./"

const New = ({goto}: TPoiPageProps): ReactElement => {
  const marker = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    marker.current = document.createElement("div")
    marker.current.className = "new-point"
    document.getElementsByClassName("app")?.item(0)?.appendChild(marker.current)

    return () => marker.current?.remove()
  }, [])


  const handleSave = () => {
    const [width, height] = mapService.getMapSize() || []
    const point = mapService.getCoordinateFromPixel([width / 2, height / 2])
    goto(PoiPage.Save, {point, props: {color: 1, title: "", more: null}} as TPoint)
  }

  const handleCancel = () => {
    goto(PoiPage.Main)
  }

  return (
    <div className="new">
      <Button className="button-primary" onClick={handleSave}>
        {t("button.save")}
      </Button>
      <Button className="cancel button-regular" onClick={handleCancel}>
        {t("button.cancel")}
      </Button>
    </div>
  )
}

export default New
